
import Hero from "../components/Hero";
import Features from "../components/Features";
import CallToAction from "../components/CallToAction";
import React, { Suspense } from 'react';

// Heavy interactive demo component – load on demand only
const AppReview = React.lazy(() => import("../components/AppReview"));


const Index = () => {
  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{
        width: '100vw',
        minWidth: '100%',
        maxWidth: '100vw',
        margin: 0,
        padding: 0,
        paddingTop: '64px', // Account for fixed header height
        boxSizing: 'border-box',
        position: 'relative',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
      }}
    >
      <Hero />
      <Features />
      {/* Demo section is large; load it only when nearing viewport */}
      <Suspense fallback={null}>
        <AppReview />
      </Suspense>
      {/* <Testimonials /> */}
      <CallToAction />
    </div>
  );
};

export default Index;
